module.exports = __webpack_public_path__ + "img/pdf.fee3a210.png";